import { SelectorRowStates } from '../../../../../../components/selectorRowV2/types/state';
import { TextVariantType } from '../../variants';
import { commonStyles } from '../commonStyles';
import { SelectorRowVariants } from '../variants';
export const getUserStyles = (FOUNDATIONS, FONT) => ({
    [SelectorRowVariants.USER]: {
        [SelectorRowStates.UNSELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_neutral_bg_300,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_400,
                },
                description: {
                    text_decoration: 'underline',
                },
            }),
        },
        [SelectorRowStates.SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_selected_bg_200,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_400,
                },
                description: {
                    text_decoration: 'underline',
                },
            }),
        },
        [SelectorRowStates.HOVER]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_hover_primary_bg_100,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_400,
                },
                description: {
                    text_decoration: 'underline',
                },
            }),
        },
        [SelectorRowStates.PRESSED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_pressed_primary_bg_200,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_400,
                },
                description: {
                    text_decoration: 'underline',
                },
            }),
        },
        [SelectorRowStates.FILLING]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_neutral_bg_300,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_400,
                },
                description: {
                    text_decoration: 'underline',
                },
            }),
        },
        [SelectorRowStates.DISABLED_UNSELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    cursor: 'auto',
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_400,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                description: {
                    text_decoration: 'underline',
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
            }),
        },
        [SelectorRowStates.DISABLED_SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    cursor: 'auto',
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_400,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                description: {
                    text_decoration: 'underline',
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
            }),
        },
    },
});
//# sourceMappingURL=user.js.map